import { graphql } from '@/gql';
import type { UsersQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchUsers = async ({ searchType, searchValue, pagination }: UsersQueryVariables) => {
  const response = await queryExecute({
    variables: {
      searchType,
      searchValue,
      pagination,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query users($searchType: String!, $searchValue: String!, $pagination: PaginationInputType) {
        users(searchType: $searchType, searchValue: $searchValue, pagination: $pagination) {
          count
          rows {
            id
            firstName
            lastName
            email
            roles
            userForms {
              id
              formId
              fileName
              fileKey
              uploadedAt
              form {
                id
                name
                description
                url
                createdAt
              }
            }
          }
        }
      }
    `),
  });

  return response.data.users;
};
